module.exports = __webpack_public_path__ + "static/media/img_br_video01.813082ab.jpg";